<div class="admin-layout">

  <!-- =========================
       SIDEBAR
  ========================== -->

  <div class="sidebar">

    <h2>
      ⚙ {{ t('adminPanel') }}
    </h2>


    <!-- DASHBOARD -->

    <a
      routerLink="/admin/dashboard"
      routerLinkActive="active"
    >
      📊 {{ t('dashboard') }}
    </a>


    <!-- PRODUCTS -->

    <a
      routerLink="/admin/products"
      routerLinkActive="active"
    >
      🛒 {{ t('products') }}
    </a>


    <!-- BULK PRODUCT IMPORT -->

    <a
      routerLink="/admin/products/import"
      routerLinkActive="active"
    >
      📥 {{ t('bulkImportProducts') }}
    </a>


    <!-- CATEGORIES -->

    <a
      routerLink="/admin/categories"
      routerLinkActive="active"
    >
      📂 {{ t('categories') }}
    </a>


    <!-- HOMEPAGE DESIGN -->

    <a
      routerLink="/admin/homepage-design"
      routerLinkActive="active"
    >
      🎨 {{ t('homepageDesignNav') }}
    </a>


    <!-- BANNERS -->

    <a
      routerLink="/admin/banners"
      routerLinkActive="active"
    >
      🖼️ {{ t('banners') }}
    </a>


    <!-- HOMEPAGE FEATURES -->

    <a
      routerLink="/admin/features"
      routerLinkActive="active"
    >
      ✨ {{ t('homepageFeatures') }}
    </a>


    <!-- SIDEBAR MENU LINKS -->

    <a
      routerLink="/admin/sidebar-links"
      routerLinkActive="active"
    >
      📋 {{ t('sidebarLinksAdmin') }}
    </a>


    <!-- SHOP & GET MORE -->

    <a
      routerLink="/admin/shop-more"
      routerLinkActive="active"
    >
      🛍️ {{ t('shopGetMore') }}
    </a>


    <!-- POPULAR BRANDS -->

    <a
      routerLink="/admin/popular-brands"
      routerLinkActive="active"
    >
      🏷️ {{ t('popularBrandsNav') }}
    </a>


    <!-- FOOTER MANAGEMENT -->

    <a
      routerLink="/admin/footer"
      routerLinkActive="active"
    >
      🧾 {{ t('footerManagement') }}
    </a>


    <!-- SITE SETTINGS (LOGO) -->

    <a
      routerLink="/admin/settings"
      routerLinkActive="active"
    >
      🎨 {{ t('siteSettingsNav') }}
    </a>


    <!-- ORDERS -->

    <a
      routerLink="/admin/orders"
      routerLinkActive="active"
    >
      📦 {{ t('ordersNav') }}
    </a>


    <!-- CUSTOMERS -->

    <a
      routerLink="/admin/customers"
      routerLinkActive="active"
    >
      👥 {{ t('customers') }}
    </a>


    <!-- PURCHASE MANAGEMENT -->

    <a
      routerLink="/admin/purchase-management"
      routerLinkActive="active"
    >
      💰 {{ t('purchaseManagement') }}
    </a>


    <!-- PURCHASE HISTORY -->

    <a
      routerLink="/admin/purchase-history"
      routerLinkActive="active"
    >
      📑 {{ t('purchaseHistory') }}
    </a>


    <!-- COMPLAINTS -->

    <a
      routerLink="/admin/complaints"
      routerLinkActive="active"
    >
      ⚠️ {{ t('complaints') }}
    </a>


    <!-- BACK TO SHOP -->

    <a
      routerLink="/"
    >
      🏠 {{ t('backToShop') }}
    </a>

  </div>


  <!-- =========================
       CONTENT
  ========================== -->

  <div class="content">

    <router-outlet>
    </router-outlet>

  </div>

</div>